import { apiService } from '@/services/APIService';

export default {
  getPollAnswers(params) {
    return apiService.get('/poll-answers', params);
  },
  getPollAnswer(id, params) {
    return apiService.get(`/poll-answers/${id}`, params);
  },

  showPollAnswer(id, params) {
    return apiService.get(`/poll-answers/${id}`, params);
  },

  /**
   * Обновление очков для ответа участника(только для организатора)
   * @param  {Number} id ответа
   * @param {score:String} params
   */
  updatePollAnswerScore(id, params) {
    return apiService.put(`/poll-answers/${id}`, params);
  },

  /**
   * Обновление очков для ответа участника(только для организатора)
   * @param  {Number} id номер журнала
   * @param  {Number} answer_id номер вопроса для журнала
   * @param {Object} params
   */
  createPollJournalAnswer(id, answer_id, params) {
    return apiService.post(`/poll-answers/answer/${id}/${answer_id}`, params);
  },

  remakePollJournalAnswer(answer_id, params) {
    return apiService.put(`/poll-answers/answer/${answer_id}?expand=images,documents,links`, params);
  },

  /**
   * Обновление очков для ответа участника(только для организатора)
   * @param  {Number} id номер журнала
   * @param {Object} payload
   */
  finishPoll(id, payload) {
    return apiService.post(`/poll-answers/finish/${id}`, payload);
  },

  undo(id, payload) {
    return apiService.post(`/poll-answers/finish/${id}/undo`, payload);
  },
};
